export const convertChannelIdToName = (channel, channels) => {
    console.log(channel);
    console.log(channels);
    if(!channel || !channels){
        return "default";
    }
    const filterChannels = channels ? channels.filter(obj => obj.increment_id == channel) : null;
    if(!filterChannels || (filterChannels && filterChannels.length == 0)){
        return "default";
    }
    return filterChannels[0].slug;
}